import * as Preact from "preact"
import Navigation from "@frog/source/models/Navigation.js"

import TestListScreen from "@frog/source/views/dev/screens/TestListScreen.view.js"
import TestDetailsScreen from "@frog/source/views/dev/screens/TestDetailsScreen.view.js"
import TestWidget from "@frog/source/views/dev/widgets/TestWidget.view.js"
import BuildWidget from "@frog/source/views/dev/widgets/BuildWidget.view.js"

import "@frog/source/views/dev/Dev.view.less"

const screens = {
    "TestListScreen": TestListScreen,
    "TestDetailsScreen": TestDetailsScreen,
}

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/utility/Dev.js"

export default class DevView {
    render() {
        if(Dev.isEnabled != true) return
        return (
            <div class="Dev">
                <div class="HeaderBar">
                    <NavigationInput/>
                    <div class="Widgets">
                        <TestWidget/>
                        <BuildWidget/>
                    </div>
                </div>
                {this.screen}
                <div class="FooterBar">
                    <SelectionInformation/>
                </div>
            </div>
        )
    }
    get screen() {
        if(Navigation.state.devscreen != undefined) {
            if(screens[Navigation.state.devscreen] != undefined) {
                const Screen = screens[Navigation.state.devscreen]
                return <Screen/>
            }
        }
    }
}

class NavigationInput {
    render() {
        return (
            <div class="NavigationInput">
                {window.location.hash}
            </div>
        )
    }
}

class SelectionInformation {
    render() {
        if(App?.game?.encounter?.selection?.position == undefined) {
            return
        }
        return (
            <div class="SelectionInformation">
                <div class="X">x={Math.floor(App.game.encounter.selection.position.x)}</div>
                <div class="Y">y={Math.floor(App.game.encounter.selection.position.y)}</div>
                <div class="Z">z={App.game.encounter.selection.position.z}</div>
            </div>
        )
    }
}
